import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CustomerSelectionService } from '../../../services/admin/customer-selection.service';

export const territorialIntelligenceGuard: CanActivateFn = () => {
  const customers = inject(CustomerSelectionService);
  const router = inject(Router);
  return customers.selectedCustomer()?.territorialIntelligenceEnabled === true
    ? true
    : router.createUrlTree(['/market-intelligence']);
};
